import React from 'react';

const POSITIONS = [
  { name: 'Senior UI/UX Designer', applications: 1240, growth: '+12%', color: 'bg-brand-primary' },
  { name: 'Full Stack Developer', applications: 980, growth: '+8%', color: 'bg-brand-secondary' },
  { name: 'Marketing Manager', applications: 850, growth: '+15%', color: 'bg-green-500' },
  { name: 'Product Owner', applications: 620, growth: '+5%', color: 'bg-yellow-500' },
  { name: 'Data Analyst', applications: 430, growth: '+2%', color: 'bg-purple-500' },
];

const MostAppliedPositions = () => {
  const maxApps = Math.max(...POSITIONS.map(p => p.applications));

  return (
    <div className="card p-6 h-full">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h3 className="text-lg font-bold text-gray-800">Most Applied Positions</h3>
          <p className="text-sm text-gray-500">Top 5 job openings by volume</p>
        </div>
        <button className="text-sm text-brand-primary font-medium hover:underline">View All</button>
      </div>

      <div className="space-y-5">
        {POSITIONS.map((pos, idx) => (
          <div key={idx} className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm font-semibold text-gray-700">{pos.name}</span>
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold text-gray-800">{pos.applications.toLocaleString()}</span>
                <span className="text-xs text-green-500 font-medium">{pos.growth}</span>
              </div>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden">
              <div 
                className={`${pos.color} h-full rounded-full transition-all duration-1000`} 
                style={{ width: `${(pos.applications / maxApps) * 100}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MostAppliedPositions;